import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "@hooks/useStore";
import { selectIsAuthenticated, selectIsTokenExpired } from "@store/slices/auth";

export default function ProtectedRouteWrapper() {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isExpired = useAppSelector(selectIsTokenExpired);

  if (!isAuthenticated || isExpired) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
